import TimeScaleSelector from './timescale-selector'

export default TimeScaleSelector
